module.exports = __webpack_public_path__ + "img/9791197434921.a5e83805.jpg";